import { render, staticRenderFns } from "./ReceiptReportDetail.vue?vue&type=template&id=476827f3"
import script from "./ReceiptReportDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports